import type { EffectiveMetaPixel, MetaPixelConfig } from './metaPixelTypes';

export function sanitizeMetaPixelId(raw: unknown): string {
  return String(raw ?? '').replace(/\D/g, '');
}

export function isValidMetaPixelId(id: string): boolean {
  return id.length >= 10 && id.length <= 20;
}

/** Docs sem metaPixel ou disabled → null (legado). */
export function resolveEffectiveMetaPixel(
  metaPixel?: MetaPixelConfig | null
): EffectiveMetaPixel | null {
  if (!metaPixel || metaPixel.enabled !== true) return null;
  const id = sanitizeMetaPixelId(metaPixel.pixelId);
  return isValidMetaPixelId(id) ? { pixelId: id, enabled: true } : null;
}
